import { ISearchFormProps } from '../../templates/house-search-layout/HouseSearchLayout'
import {
  DataSortEnum,
  FilterBudgetTypeEnum,
  TravelTypeEnum,
} from '../../../lib/graphql'

export const houseSearchDefaultValues: ISearchFormProps = {
  travelType: TravelTypeEnum.NIGHTLY_TRIP,
  dates: {},
  budget: {
    budgetMin: 0,
    budgetMax: 500,
    filterBudgetType: FilterBudgetTypeEnum.ALL_INCLUSIVE,
  },
  sortBy: DataSortEnum.PERTINENT,
}
